import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import WmsSidebar from '../../components/WmsSidebar';
import WmsTopbar from '../../components/wms_topbar';
import { receptionFlows } from '../../flows/receptionFlows';
import RecepcionEscanearOrden from './RecepcionEscanearOrden';
// Importación de íconos de Material UI
import Inventory2Icon from '@mui/icons-material/Inventory2'; // pedidos
import LocalShippingIcon from '@mui/icons-material/LocalShipping'; // sin pedido
import PercentIcon from '@mui/icons-material/Percent'; // muestreo
import BlockIcon from '@mui/icons-material/Block'; // cuarentena
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn'; // devolucion
import WidgetsIcon from '@mui/icons-material/Widgets'; // palletizado

const WmsRecepcion = () => {
  const [activeItem, setActiveItem] = useState('recepcion');
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleStartFlow = (flowKey) => {
    navigate(`/wms/recepcion/flow/${flowKey}`);
  };

  const handleScanOrder = () => {
    navigate('/wms/recepcion/escanear');
  };

  return (
    <div className="flex">
      {/* Sidebar drawer solo en móvil */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}
      <div
        className={`fixed z-50 inset-y-0 left-0 transition-transform duration-300 md:hidden ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}
        style={{ width: '256px', minHeight: '100vh' }}
      >
        <WmsSidebar activeItem={activeItem} setActiveItem={setActiveItem} />
      </div>
      {/* Sidebar estático solo en desktop, en el flujo normal */}
      <div className="hidden md:flex">
        <WmsSidebar activeItem={activeItem} setActiveItem={setActiveItem} />
      </div>
      <div className="flex-1 bg-gray-100 min-h-screen md:p-6">
        <WmsTopbar rightContent={
          <button
            className="md:hidden p-2 ml-2"
            onClick={() => setSidebarOpen(true)}
            aria-label="Abrir menú"
            style={{ background: 'transparent', border: 'none', boxShadow: 'none' }}
          >
            <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="feather feather-menu"><line x1="3" y1="12" x2="25" y2="12"/><line x1="3" y1="6" x2="25" y2="6"/><line x1="3" y1="18" x2="25" y2="18"/></svg>
          </button>
        } />
        <h1 className="text-2xl font-bold mb-2 text-center">Recepción de Mercancía</h1>
        <p className="mb-6 text-center text-gray-700">Registro y control de entradas: pedidos, devoluciones, muestreo, cuarentena y más.</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {receptionFlows.map(flow => {
            let icon;
            switch (flow.key) {
              case 'recepcion-pedidos':
                icon = <Inventory2Icon className="text-blue-600 bg-blue-100 rounded-full p-2 mb-2 shadow-sm" style={{ fontSize: 48 }} />; break;
              case 'palletizado':
                icon = <WidgetsIcon className="text-gray-600 bg-gray-100 rounded-full p-2 mb-2 shadow-sm" style={{ fontSize: 48 }} />; break;
              case 'recepcion-sin-pedido':
                icon = <LocalShippingIcon className="text-green-600 bg-green-100 rounded-full p-2 mb-2 shadow-sm" style={{ fontSize: 48 }} />; break;
              case 'recepcion-muestreo':
                icon = <PercentIcon className="text-yellow-600 bg-yellow-100 rounded-full p-2 mb-2 shadow-sm" style={{ fontSize: 48 }} />; break;
              case 'recepcion-cuarentena':
                icon = <BlockIcon className="text-orange-600 bg-orange-100 rounded-full p-2 mb-2 shadow-sm" style={{ fontSize: 48 }} />; break;
              case 'recepcion-devolucion':
                icon = <AssignmentReturnIcon className="text-purple-600 bg-purple-100 rounded-full p-2 mb-2 shadow-sm" style={{ fontSize: 48 }} />; break;
              
              default:
                icon = <Inventory2Icon className="text-gray-500 bg-gray-100 rounded-full p-2 mb-2 shadow-sm" style={{ fontSize: 48 }} />;
            }
            return (
              <button
                key={flow.key}
                className="flex flex-col items-center justify-center bg-white border border-gray-200 hover:border-blue-400 hover:shadow-lg text-gray-800 rounded-xl p-4 shadow transition text-center focus:outline-none focus:ring-2 focus:ring-blue-300 group disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={() => handleStartFlow(flow.key)}
                disabled={['recepcion-sin-pedido','recepcion-muestreo','recepcion-cuarentena','recepcion-devolucion'].includes(flow.key)}
              >
                {icon}
                <span className="font-semibold text-sm leading-tight group-hover:text-blue-700 transition-colors">{flow.label}</span>
                <span className="text-[11px] text-gray-500 font-normal mt-1 group-hover:text-blue-500 transition-colors">{flow.description}</span>
              </button>
            );
          })}
        </div>
        <div className="mt-8 text-center">
          
        </div>
      </div>
    </div>
  );
};

export default WmsRecepcion;
